import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Header as ModalHeader } from '~/components/Modal/styles';
import grid from '~/styles/grid';

export default makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  typography: {
    marginTop: theme.spacing(10),
    fontFamily: ['"Exo 2"', 'sans-serif'].join(','),
  },
}));

export const Container = styled.div`
  font-family: 'Exo 2', sans-serif;

  h1 {
    font-family: Exo 2;
    font-size: 20px;
    font-weight: normal;
    color: #4d4d4d;
  }

  > h1 {
    font-weight: normal;
    font-size: 24px;
    color: #4d4d4d;
    margin: 0.5rem 0 2.2rem 0;

    /* &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: 16px 0 40px 0;
    } */
  }

  h2 {
    font-family: Exo 2;
    font-size: 20px;
    font-weight: normal;
    color: #4d4d4d;
    margin-top: 2.2rem;
  }

  span {
    font: 14px 'Exo 2', sans-serif;
  }

  ${ModalHeader} {
    height: 1.6px;
    border: none;
  }
`;

export const Title = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  /* margin-left: 0.938rem;
  margin-bottom: -0.875rem; */
  cursor: pointer;

  margin-top: ${grid.lg};
  margin-bottom: ${grid.lg};
`;

export const ButtonsContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const Subtitle = styled.div`
  display: flex;
  align-items: center;

  h1 {
    font-size: 24px;
    color: #4d4d4d;
  }

  p {
    font-size: 14px;
    color: #777777;
    margin: 0;
    padding: 0;
    margin-right: 0.5rem;
  }

  button {
    display: inline-flex;
    align-items: center;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: #eb0045;
    margin-left: 0.5rem;
  }
`;

export const FormButton = styled.button`
  width: 64.2rem;
  height: 14.2rem;
  background: transparent;
  border: 1px dashed #eb0045;
`;

export const ButtonOption = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  width: 16.2rem;
  height: 12.8rem;
  margin-top: 1.1rem;
  padding: 0.7rem;

  h2 {
    font-family: Exo 2;
    font-size: 18px;
    color: #4d4d4d;
  }

  p {
    color: #777777;
  }

  svg {
    color: #eb0045;
    width: 2.3rem;
    height: 2.3rem;
  }
`;

export const ModalContainer = styled.div`
  .ps__rail-y {
    display: none;
  }
  .fMbDSX {
    margin: -0.7rem;
  }
  .fMbDSX::after {
    background: transparent;
  }
  .bXscyI {
    padding: 0.4rem;
    height: 17.1rem;
  }
`;

export const ModalContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  margin: 0 0 4.2rem 4.2rem;
`;

export const ModalSubmitButton = styled.button``;

export const ModalContent = styled.div`
  width: 23.5rem;
  text-align: center;

  div {
    margin-top: 2.1rem;

    button {
      background: transparent;
      border: none;
      color: #4d4d4d;
    }

    ${ModalSubmitButton} {
      background: #eb0045;
      border: none;
      border-radius: 5px;
      height: 2.1rem;
      width: 7.1rem;
      color: #ffffff;
      margin-left: 2.1rem;
    }
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffebeb;
  color: #c11e1e;
  font-size: 14px;
`;

export const ErrorHeader = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  margin: 0.715rem;

  div {
    gap: 0.715rem;
    display: flex;
    align-items: center;
  }
`;

export const ErrorBody = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2.715rem 1rem 2.715rem;
  gap: 0.25rem;
`;

export const ErrorFileLink = styled.div`
  margin-right: 3rem;
  color: #006e99;
  cursor: pointer;
`;
